import { isTypedRowSection } from "@shared/constants/typed-sections";

/**
 * s237 (ACROSS-YOUR-PLAN-1 PR B; rule 159 — one job, one piece) — THE request that saves one answer to one row's cell,
 * wherever the planner meets it: the plan home's needs panel and Where things are build it here, and it is the same
 * request the chapter screens send (`useSectionRows`): a typed section's real row saves as its typed record
 * (`/typed-rows`, D-229.68(b)); every other row — a locked built-in row, a card — saves its cell (`/generic-entries`).
 * Building only: the caller sends it inside its own mutation (the single-flight guard's rule).
 */
export interface CellTarget {
  sectionSlug: string;
  sectionId: string;
  categoryId: string | null;
  rowId: string | null;
}

const UUID_ROW = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function cellAnswerRequest(clientId: string, t: CellTarget, fieldId: string, value: string): { url: string; body: Record<string, unknown> } {
  if (isTypedRowSection(t.sectionSlug) && UUID_ROW.test(t.rowId ?? "")) {
    return { url: `/api/clients/${clientId}/typed-rows`, body: { categoryId: t.categoryId, sectionId: t.sectionId, rowId: t.rowId, cells: [{ fieldId, value }] } };
  }
  return { url: `/api/clients/${clientId}/generic-entries`, body: { categoryId: t.categoryId, sectionId: t.sectionId, fieldId, rowId: t.rowId, value } };
}
